import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import MerchantGroupFields from "./MerchantGroupFields";

export const MerchantGroupCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <MerchantGroupFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default MerchantGroupCreate
